import useSWR from 'swr'

import { useCallMutation } from '@/common/api/client'
import { AuthApiPath, GetMeResponse } from '@/common/api/params/auth'

export const useMeGetApi = () => {
  return useSWR<GetMeResponse, Response>(AuthApiPath.ME)
}

export const useAuthorizedMe = () => {
  const { data, isLoading } = useMeGetApi()

  return {
    operatorMe: data,
    isLoading,
    isAdmin: !!data?.is_admin,
    // サイト内管理操作（オペレーター/権限テンプレートの新規・編集・削除）が可能か
    canManage: !!data?.can_manage
  }
}

export const useCallLogout = ({
  onSuccess,
  onError
}: {
  onSuccess: () => void
  onError: (error: Response) => void
}) => {
  const { trigger } = useCallMutation<{}, {}>(AuthApiPath.LOGOUT, {
    onSuccess: onSuccess,
    onError: onError
  })

  return () => {
    trigger({})
  }
}
